<template>
  <div v-loading="loading" class="ABomTree">
    <div v-if="!is_edit_mode">
      <ATree
        ref="tree"
        value-field-name="id"
        text-field-name="name"
        :data="nodes"
        :collapse="collapse"
        @item-click="handleItemClick"
      />
      <div class="mt-default size-desc">
        <div class="inline">
          <el-input :value="util.addComma(door_size)" readonly>
            <template slot="prepend">도어</template>
          </el-input>
        </div>
        <div class="inline">
          <el-input :value="util.addComma(rail_size)" readonly>
            <template slot="prepend">레일</template>
          </el-input>
        </div>
        <div class="inline">
          <el-input :value="util.addComma(belt_size)" readonly>
            <template slot="prepend">벨트</template>
          </el-input>
        </div>
      </div>
      <div class="mt-default" v-if="editable">
        <!-- <el-button 
          size="tiny"
          :disabled="!selected_data"
          @click="handleClickModify"
        >수정</el-button> -->
      </div>
    </div>
    <div v-else class="border" style="width: 450px; padding: 10px;">
      <AProductForm
        v-if="is_edit_mode"
        :data="form_data"
        @completed="handleCompletedForm"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ATree from "./ATree";
import AProductForm from "./AProductForm";

export default {
  name: "ABomTree",
  components: { ATree, AProductForm },
  data() {
    return {
      bom_count: 0, // 재귀호출되기 때문에 끝나는 것을 확인하기 위해 선언
      product_boms: [], // 제품별 BOM을 저장하는 배열
      nodes: [], // BOM을 트리구조로 변환한 배열
      loading: false,
      bom_items: [], // BOM 저장 배열
      production_items: [], // 생산제품을 저장하는 배열
      material_items: [], // 자제품을 저장하는 배열
      door_size: 0, // 도어 치수
      rail_size: 0, // 레일 치수
      belt_size: 0, // 벨트 치수
      seq: 0,
      selected_data: null,
      form_data: null,
      is_edit_mode: false,
      loading_partial: false, //노드 변경으로 인한 BOM 로드 여부
    };
  },
  props: {
    /**
     * BOM 품목 ID
     */
    id: { type: Number },
    /**
     * 사양
     */
    size: String,
    collapse: { type: Boolean, default: false },
    data: Object,
    specifications: Array,
    options: Object,
    selectionMode: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
  },
  watch: {
    id: function(val) {
      if (val) {
        this.loadData();
      }
    },
    bom_count: function(val) {
      // 모든 제품별 BOM을 가져오면 BOM을 트리구조로 변환한다.
      if (val === 0) {
        if (this.loading_partial) {
          this.initPartialBOM(this.selected_data);
        } else {
          this.initBOM();
        }
      }
    },
    size: function() {
      this.calculateSize();
    },
  },
  mounted() {
    if (this.data && this.data.bom.length > 0) {
      this.parseData();
    } else {
      this.loadData();
    }
  },
  computed: {
    ...mapGetters(["table_product", "table_unit", "table_option"]),
  },
  methods: {
    /**
     * 모든 품목에 대한 BOM을 불러온다.
     */
    async loadData() {
      this.loading = true;
      this.product_boms = [];
      this.calculateSize();
      // TODO 아래로 대체되어야 하나 사양 정보도 같이 보내져야 함
      // const res = await this.api.listBOMTree(this.id);
      const res = await this.api.selectBOM(this.id);
      this.handleResponseBOM(res.data);
      let ids = [];
      if (this.specifications && this.specifications.length > 0) {
        this.specifications.forEach((s) => {
          if (s.option_id) {
            let option = this.table_option.find((o) => o.id === s.option_id);
            if (option) {
              option.addition.forEach((a) => {
                // if (a.is_use_assembled_option === "N")
                ids.push(a.product_id);
              });
            }
          } else if (s.product_id) {
            ids.push(s.product_id);
          }
        });
      }
      if (
        this.options &&
        this.options.descriptions &&
        this.options.descriptions.length > 0
      ) {
        // 기계 옵션 사양은 사양으로 등록되었기 때문에 비고 사양만 작업하면 된다.
        this.options.descriptions.forEach((d) => {
          let option = this.table_option.find((o) => o.id === d.id);
          if (option) {
            option.addition.forEach((a) => {
              // if (a.is_use_assembled_option === "N")
              ids.push(a.product_id);
            });
          }
        });
      }
      this.bom_count = 1;
      this.boms = [];
      this.bom_items = [];
      this.production_items = [];
      this.material_items = [];

      // 최상위 BOM을 불러온다.
      await this.loadBOMs(ids);
    },
    parseData() {
      this.seq = 0;
      this.loading = true;
      this.nodes = [];
      this.door_size = this.data.size.door;
      this.rail_size = this.data.size.rail;
      this.belt_size = this.data.size.belt;
      this.data.bom.forEach((bom) => {
        this.parseNode(bom);
      });
      this.loading = false;
      this.organizeBoms();
    },
    parseNode(bom) {
      let product = this.getProduct(bom.product_id);
      let icon = this.hasChildren(bom.bom_id) ? "fas fa-box" : "fas fa-cog";
      if (!bom.unit_id) {
        bom.unit_id = 1;
      }
      let unit = this.table_unit.find((u) => u.id === bom.unit_id);
      let node = {
        id: this.seq++,
        bom_id: bom.bom_id,
        name: product.name,
        children: [],
        icon: icon,
        unit_id: bom.unit_id,
        product_id: bom.product_id,
        product_name: product.name,
        amount: bom.amount,
        size: bom.size,
      };
      if (node.size) {
        node.name += " [" + node.size + "]";
      }
      node.name += " " + node.amount + unit.name;
      if (bom.modified) {
        node.icon += " modified";
      }
      if (bom.parent_id) {
        let parent = this.searchParentNode(this.nodes, bom.parent_id);
        parent.children.push(node);
      } else {
        this.nodes.push(node);
      }
    },
    hasChildren(id) {
      return this.data.bom.find((b) => b.parent_id === id);
    },
    /**
     * material과 production에 제품 정보가 저장되어 있기 때문에
     * 해당 배열에서 제품 정보를 찾는다.
     */
    getProduct(id) {
      let item = this.data.material.find((d) => d.id === id);
      if (!item) {
        item = this.data.production.find((d) => d.id === id);
      }
      return item;
    },
    /**
     * 특정 품목에 대한 BOM을 조회한다.
     * 트리 업데이트 도중에 재귀적으로 호출된다.
     */
    async loadBOM(item) {
      // 이미 조회했는지 검색
      let index = this.product_boms.findIndex(
        (bom) => bom.product_id === item.product_id
      );
      if (index > -1) {
        this.bom_count--;
        return;
      }
      const res = await this.api.selectBOM(item.product_id);
      let bom = res.data;
      if (!bom || bom.use_flag !== "Y") {
        this.bom_count--;
        return;
      }
      // 1차 BOM을 배열에 담는다.
      this.product_boms.push(bom);
      if (!bom.details) {
        this.bom_count--;
        return;
      }
      let ids = [];
      this.bom_count++;
      bom.details.forEach((d) => {
        // if (d.is_use_assembled_detail === "N")
        ids.push(d.product_id);
      });
      await this.loadBOMs(ids);
      this.bom_count--;
    },
    /**
     * 여러 품목에 대한 BOM을 조회한다.
     * 하위에 또 있다면 재귀적으로 호출된다.
     */
    async loadBOMs(indexes) {
      const res = await this.api.listBOMs(indexes);
      let boms = res.data;
      let ids = [];
      boms.forEach((bom) => {
        if (bom && bom.use_flag === "Y" && bom.is_use_assembled === "N") {
          this.product_boms.push(bom);
          bom.details.forEach((d) => {
            // if (d.is_use_assembled_detail === "N")
            ids.push(d.product_id);
          });
        }
      });
      if (ids.length > 0) {
        this.bom_count++;
        await this.loadBOMs(ids);
      }
      this.bom_count--;
    },
    // BOM 로드가 모두 끝나면 BOM 트리 구조로 변환
    initBOM() {
      this.seq = 0;
      let nodes = [];
      let bom = this.product_boms.find((item) => item.product_id === this.id);
      if (!bom || !bom.details) {
        this.organizeBoms();
        this.loading = false;
        return;
      }
      bom.details.forEach((d) => {
        if (d.size) {
          d.size = d.size.replace("{R}", this.rail_size);
          d.size = d.size.replace("{B}", this.belt_size);
        }
        let condition = true;
        if (d.condition) {
          let condition_string = d.condition.replace("{R}", this.rail_size);
          condition_string = condition_string.replace("{B}", this.belt_size);
          condition = eval(condition_string);
        } else {
          condition = true;
        }
        if (condition) {
          nodes.push(this.makeNode(d));
        }
      });
      if (this.specifications && this.specifications.length > 0) {
        let bom2;
        this.specifications.forEach((s) => {
          if (s.option_id) {
            // 옵션 사양 처리
            let option = this.table_option.find((o) => o.id === s.option_id);
            this.processOption(
              nodes,
              option,
              s.plan_amount || s.per_amount || s.amount
            );
          } else {
            // 일반 사양 처리
            const s_bom = this.product_boms.find(
              (item) => item.product_id === s.product_id
            );
            bom2 = {
              product_id: s.product_id,
              amount: s.plan_amount || s.per_amount || s.amount,
              unit_id: s.unit_id,
              id: s_bom ? s_bom.id : undefined,
            };
            nodes.push(this.makeNode(bom2, 1));
          }
        });
      }
      // 기계 옵션 처리
      if (
        this.options &&
        this.options.descriptions &&
        this.options.descriptions.length > 0
      ) {
        this.options.descriptions.forEach((d) => {
          let option = this.table_option.find((o) => o.id === d.id);
          this.processOption(nodes, option, 1);
        });
      }
      this.nodes = nodes;
      this.organizeBoms();
      this.loading = false;
    },
    /**
     * 사양/비고 옵션 처리
     */
    processOption(nodes, option, amount) {
      if (!option) {
        return;
      }
      let unit_id = 1;
      // 추가 품목을 추가한다.
      // 참조 품목이 제외되는 상황이 있으므로 추가 > 삭제 순으로 진행한다.
      if (option.addition.length > 0) {
        let multiply = 1;
        let parent;
        // 참조 수량을 확인한다.
        if (option.reference_product_flag === "Y") {
          let reference_product = this.searchNodeByProduct(
            nodes,
            option.reference_product_id
          );
          if (reference_product) {
            multiply = reference_product.amount;
            unit_id = reference_product.unit_id;
            parent = this.searchParentNodesByProduct(
              nodes,
              reference_product.product_id
            );
          }
        }
        for (const add of option.addition) {
          let add_amount = 0;
          if (add.individual_amount_flag === "Y") {
            add_amount = add.amount * amount;
          } else {
            add_amount = multiply * add.amount * amount;
          }
          // 참조수량
          let bom2 = {
            product_id: add.product_id,
            amount: add_amount,
            unit_id: unit_id,
          };
          let bom_item = this.product_boms.find(
            (b) => b.product_id === add.product_id
          );
          if (bom_item) {
            bom2.id = bom_item.id;
          }
          if (parent) {
            parent.children.push(this.makeNode(bom2, 1));
          } else {
            nodes.push(this.makeNode(bom2, 1));
          }
        }
      }
      // 제거해 준다.
      if (option.subtraction.length > 0) {
        option.subtraction.forEach((sub) => {
          this.removeNode(nodes, sub.product_id);
        });
      }
    },
    removeNode(nodes, product_id) {
      let index = nodes.findIndex((n) => n.product_id === product_id);
      if (index > -1) {
        nodes.splice(index, 1);
      } else {
        nodes.forEach((node) => {
          this.removeNode(node.children, product_id);
        });
      }
    },
    /**
     * 특정 품목의 BOM 정보를 초기화한다.
     * 노드에서 품목 변경시 실행된다.
     */
    initPartialBOM(node) {
      let bom = this.product_boms.find(
        (item) => item.product_id === node.product_id
      );
      if (!bom || !bom.details) {
        this.organizeBoms();
        this.loading = false;
        return;
      }
      bom.details.forEach((d) => {
        if (d.size) {
          d.size = d.size.replace("{R}", this.rail_size);
          d.size = d.size.replace("{B}", this.belt_size);
        }
        node.addChild(this.makeNode(d));
      });
      this.organizeBoms();
      this.loading = false;
    },
    // BOM 트리 노드로 변환하고 생산품과 자제품을 분류한다.
    makeNode(data, modified = 0) {
      // 제품 정보를 얻어서 노드를 생성한다.
      let product = this.table_product.find((p) => p.id === data.product_id);
      let unit_id = data.unit_id ? data.unit_id : 1;
      let unit = this.table_unit.find((u) => u.id === unit_id);
      let node = {
        id: this.seq++,
        bom_id: data.id,
        children: [],
        selected: false,
        product_name: product.name,
        product_id: product.id,
        size: data.size || product.size,
        amount: data.amount,
        unit_id: data.unit_id,
        unit_name: unit.name,
        // icon: "fas fa-cog",
      };
      node.name = product.name;
      if (node.size) {
        node.name += " [" + node.size + "]";
      }
      node.name += " " + data.amount + unit.name;
      let bom = this.product_boms.find(
        (item) => item.product_id === product.id
      );
      if (bom && bom.details.length > 0) {
        for (const d of bom.details) {
          node.children.push(this.makeNode(d));
        }
        if (node.children.length > 0) {
          node.icon = "fas fa-toolbox";
        }
      }
      if (node.children.length > 0) {
        node.icon = "fas fa-box";
      } else {
        node.icon = "fas fa-cog";
      }
      if (modified) {
        node.modified = modified;
        node.icon += " modified";
      }
      return node;
    },
    searchParentNode(nodes, id) {
      let node = nodes.find((node) => node.bom_id === id);
      if (node) {
        return node;
      }
      nodes.forEach((n) => {
        if (n.children.length > 0) {
          node = this.searchParentNode(n.children, id);
        }
        if (node) {
          return true;
        }
      });
      return node;
    },
    // 결과 반환. completed 후에 호출
    getResult() {
      return {
        bom: this.bom_items,
        production: this.production_items,
        material: this.material_items,
        size: {
          door: this.door_size,
          rail: this.rail_size,
          belt: this.belt_size,
        },
      };
    },
    /**
     * 현재 BOM의 노드 정보만 담은 배열을 반환
     */
    organizeBoms() {
      this.bom_items = [];
      this.production_items = [];
      this.material_items = [];
      this.nodes.forEach((node) => {
        // if (!this.selectionMode || node.selected) {
        this.bom_items.push(...this.organizeBom(node));
        // }
      });
      const result = this.getResult();
      this.$emit("completed", result);
    },
    /**
     * 노드의 BOM 정보를 반환한다.
     * 선택된 노드에 대해서만 호출한다.
     * 생산/자제 품목을 정리한다.
     */
    organizeBom(node, parent, ancestor_amount = 1) {
      let items = [];
      let item = {
        bom_id: node.bom_id,
        product_id: node.product_id,
        size: node.size,
        amount: node.amount,
        unit_id: node.unit_id,
      };
      if (parent) {
        item.parent_id = parent.bom_id;
      }
      if (node.modified) {
        item.modified = 1;
      }
      items.push(item);
      // 생산, 자재에는 품목의 단위로 등록한다.
      let product = this.table_product.find((p) => p.id === node.product_id);
      let amount = node.amount;
      let unit_id = node.unit_id;
      let unit_name = "EA";
      // 노드에 등록된 단위가 제품의 단위와 다르다면 제품단위로 계산한다.
      if (
        product.size_amount_flag !== "Y" &&
        product.unit_id !== node.unit_id
      ) {
        let product_unit = this.table_unit.find(
          (u) => u.id === product.unit_id
        );
        let current_unit = this.table_unit.find(
          (u) => u.id === (node.unit_id ? node.unit_id : 1)
        );
        unit_id = product.unit_id;
        unit_name = product.unit_name;
        if (current_unit.multiply) {
          amount = Number.parseFloat(amount) * current_unit.multiply;
        }
        if (product_unit.multiply) {
          amount = Number.parseFloat(amount) / product_unit.multiply;
        }
      }
      let element = {
        id: node.product_id,
        name: node.product_name,
        size: node.size,
        amount: ancestor_amount * amount,
        unit_id: unit_id,
        unit_name: unit_name,
      };
      /**
       * ERP-661 재고 출하 프로세스 문제점
       * 등록되는 노드가 옵션에 포함된 품목이면, option_flag 를 설정
       * back-end에서 option_flag 가 설정되어 있으면,
       * 재고 처리 부분에서 입고 처리만 하고 출고 처리는 하지 않게 하기 위함
       */
      let option_item =
        this.specifications &&
        this.specifications.find(
          (findItem) => findItem.product_id === node.product_id
        );
      //TODO 옵션에 2개 이상 품목이 있을 수 있음. 현재는 첫번째 품목만 설정됨
      if (option_item) element.option_flag = true;
      // BOM이 있으면 생산품, 없으면 자제품 배열에 삽입
      let target =
        node.children.length > 0 ? this.production_items : this.material_items;
      let old = target.find(
        (i) => i.id == element.id && i.size == element.size
      );
      if (old) {
        old.amount += element.amount;
      } else {
        target.push(element);
      }
      if (node.children.length > 0) {
        node.children.forEach((c) => {
          items.push(...this.organizeBom(c, item, element.amount));
        });
      }
      return items;
    },
    /**
     * 트리 구조의 노드에서 특정 노드를 찾기 위한 함수
     */
    searchBomData(items, id) {
      let item = items.find((item) => item.bom_id === id);
      return item;
    },
    /**
     * 레일 및 벨트 치수를 계산한다.
     */
    calculateSize() {
      if (!this.size) {
        return;
      }
      let product = this.table_product.find((p) => p.id === this.id);
      // 쌍도어인지 검색
      let good_size = this.util.getGoodSize(this.size, product);
      this.rail_size = good_size.rail_size;
      this.door_size = good_size.door_size;
      this.belt_size = good_size.belt_size;
    },
    updateNode(old_node, new_node) {
      let reload_bom = old_node.product_id !== new_node.product_id;
      let u = this.table_unit.find((u) => u.id === new_node.unit_id);
      new_node.unit_name = u.name;
      if (reload_bom) {
        old_node.product_id = new_node.product_id;
        old_node.product_name = new_node.product_name;
        old_node.children = [];
      }
      old_node.amount = new_node.amount;
      old_node.size = new_node.size;
      old_node.unit_id = new_node.unit_id;
      old_node.unit_name = new_node.unit_name;
      old_node.modified = 1;
      if (old_node.icon.indexOf("modified") < 0) {
        old_node.icon += " modified";
      }
      let name = new_node.product_name;
      if (new_node.size) {
        name += " [" + new_node.size + "]";
      }
      name += " " + new_node.amount + new_node.unit_name;
      old_node.name = name;
      if (reload_bom) {
        this.loading_partial = true;
        this.bom_count = 1;
        this.loadBOM(old_node);
      } else {
        this.organizeBoms();
      }
    },
    searchNode(nodes, node) {
      let result;
      nodes.forEach((n) => {
        if (n.id === node.id) {
          result = n;
        }
        if (result) {
          return result;
        }
        if (n.children) {
          result = this.searchNode(n.children, node);
        }
        if (result) {
          return result;
        }
      });
      return result;
    },
    searchNodeByProduct(nodes, product_id) {
      let result;
      nodes.forEach((n) => {
        if (n.product_id === product_id) {
          result = n;
        }
        if (result) {
          return result;
        }
        if (n.children) {
          result = this.searchNodeByProduct(n.children, product_id);
        }
        if (result) {
          return result;
        }
      });
      return result;
    },
    searchParentNodesByProduct(nodes, product_id) {
      let result;
      nodes.some((node) => {
        result = this.searchParentNodeByProduct(node, product_id);
        if (result) {
          return true;
        }
      });
      return result;
    },
    searchParentNodeByProduct(node, product_id) {
      let result;
      if (node.children && node.children.length > 0) {
        node.children.some((c) => {
          if (c.product_id === product_id) {
            result = node;
          }
          if (result) {
            return true;
          }
          if (c.children) {
            result = this.searchParentNodeByProduct(c, product_id);
          }
          if (result) {
            return true;
          }
        });
      }
      return result;
    },
    /**
     * BOM에 대한 응답을 저장하고 하위 BOM 갯수를 저장한다.
     */
    handleResponseBOM(bom) {
      if (!bom || bom.use_flag !== "Y" || bom.is_use_assembled === "Y") {
        this.bom_count--;
        return;
      }
      this.product_boms.push(bom);
      if (!bom.details) {
        this.bom_count--;
        return;
      }
      this.bom_count++;
      let ids = [];
      bom.details.forEach((d) => {
        // if (d.is_use_assembled_detail === "N")
        ids.push(d.product_id);
      });
      this.loadBOMs(ids);
      this.bom_count--;
    },
    handleResponseBOMs(boms) {
      if (boms.length < 1) {
        this.bom_count--;
        return;
      }
      let ids = [];
      boms.forEach((bom) => {
        this.product_boms.push(bom);
        if (bom.details && bom.details.length > 0) {
          bom.details.forEach((d) => {
            ids.push(d.product_id);
          });
        }
      });
      if (ids.length > 0) {
        this.bom_count++;
        this.loadBOMs(ids);
      }
      this.bom_count--;
    },
    handleItemClick(node, item) {
      this.selected_data = item;
      this.form_data = Object.assign({}, item);
    },
    handleClickModify() {
      this.is_edit_mode = true;
    },
    handleCompletedForm(result) {
      if (result) {
        this.updateNode(this.selected_data, result);
      }
      this.is_edit_mode = false;
    },
    handleChangeAllowReplace() {
      this.loadData();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/_variables.scss";

.ABomTree {
  .modified {
    color: $color-danger;
  }
  .size-desc {
    > div {
      width: 30%;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
  }
}
</style>
